import React from 'react'
import { LightTagProps } from './LightTag.types'
import styles from './LightTag.module.scss'
import cl from 'classnames'

const LightTagComponent = (props: LightTagProps) => {
  const {
    text,
    children
  } = props

  return (
    <span className={cl(styles.lightTag)}>
      {text || children}
    </span>
  )
}

const LightTag = LightTagComponent
export { LightTag }
